const { getElement } = window.BAO.Utils

class FauxOptions extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)

    this.els.trigger.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleTrigger)
    })
  }

  handleTrigger (event) {
    const clickedTrigger = event.target.closest(
      '[data-faux-options-el="trigger"]',
    )

    if (!clickedTrigger) return

    if (
      clickedTrigger.closest(
        '[data-view-similar-external-el="trigger"], [data-back-in-stock-external-el="trigger"]',
      )
    ) {
      return
    }

    const matchedOption = getElement(
      `[data-variant-radios-el="option-choice"][id='${clickedTrigger.dataset.id}'][name='${clickedTrigger.dataset.name}'][data-value='${clickedTrigger.dataset.value}']`,
    )

    if (!matchedOption) return
    matchedOption.checked = true
    matchedOption.dispatchEvent(new Event('change', { bubbles: true }))
  }
}

if (!customElements.get('faux-options')) {
  customElements.define('faux-options', FauxOptions)
}
